module.exports = __webpack_public_path__ + "img/base_activites_accrobranche.acdceed5.svg";